import moment from 'moment';
import Tolls from '../../../../services/toll';
import { cpfCnpj } from '../../../../filters/string'

export default{
  props: ['vpData'],
  data() {
    return {
      dataTransfer:undefined,
      loading: undefined,
      summaryVP: {},
      origin: {},
      destination: {},
    }
  },
  computed: {
    getDateTransfer() {
      return moment().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY [via website.]')
    }
  },

  methods: {
    print() {
      var prtContent = document.getElementById("comprovante");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    closeModal() {
      let close = {
        modal: 'receipt-vp'
      };
      this.$emit('close', close);
      this.summaryVP = {};
    }
  },
  mounted(){
      $('[data-toggle="tooltip"]').tooltip();

      return this.loading = Tolls.getById(this.vpData.idVP).then(resp => {
        this.summaryVP = resp;
        this.origin.city = resp.origem.substring(0, resp.origem.indexOf(','));
        this.origin.state = resp.origem.substring(resp.origem.indexOf(',') +1, resp.origem.indexOf(',') +4);
        this.destination.city = resp.destino.substring(0, resp.destino.indexOf(','));
        this.destination.state = resp.destino.substring(resp.destino.indexOf(',') +1, resp.destino.indexOf(',') +4);
        this.summaryVP.CNPJTransportador = cpfCnpj(resp.CNPJTransportador);
      }).catch(err => {
        
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-receipt-vp.js